'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    EditorGalleryImage = require('./EditorGalleryImage'),
    GalleryLayouts = require('../constants/GalleryLayouts'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    EditorSectionMixin = require('../mixins/EditorSectionMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    DragItemTypes = require('../constants/DragItemTypes'),
    StampDraftStore = require('../stores/StampDraftStore'),
    EditorDragImages = require('../constants/EditorDragImages'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    { DragDropMixin, ImagePreloaderMixin } = require('react-dnd'),
    { PropTypes } = React;

require('./legacy/Section.less');

var MAX_IMAGES = 10;

var EditorGallery = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, EditorSectionMixin],

  className: 'editor-Section editor-Section--gallery',

  propTypes: {
    uuid: PropTypes.string.isRequired,
    images: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    layout: PropTypes.string.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    isNew: PropTypes.bool
  },

  isEmpty() {
    return !this.props.images.length;
  },

  getGalleryState() {
    if (this.isEmpty()) {
      return 'empty';
    } else if (this.props.images.length >= MAX_IMAGES){
      return 'full';
    } else {
      return 'images';
    }
  },

  getSectionDragPreviewUrl() {
    var scale = this.getDragImageScale(),
        image = EditorDragImages.GALLERY;

    return getThumbnailUrl(image, {
      mode: 'preview',
      width: Math.round(image.size.width / image.intendedScale * scale),
      height: Math.round(image.size.height / image.intendedScale * scale)
    });
  },

  getImageUrlsToPreload() {
    return [this.getSectionDragPreviewUrl()];
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.SECTION, {
      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
      dropTarget: this.getSectionDropTarget()
    });

    registerType(DragItemTypes.IMAGE, {
      dropTarget: {
        getDropEffect(allowedEffects) {
          if (this.props.images.length >= MAX_IMAGES) {
            return null;
          } else {
            return allowedEffects[0];
          }
        },

        canDrop(item) {
          return item.galleryId !== this.props.uuid;
        },

        acceptDrop(item) {
          if (this.props.images.length < MAX_IMAGES) {
            DraftActionCreators.addGalleryImage(this.props.uuid, item.image);
          }
        }
      }
    });
  },

  componentDidMount() {
    if (this.props.isNew) {
      this.getDOMNode().scrollIntoViewIfNeeded();

      DraftActionCreators.resetLastAddedItem();
    }
  },

  render() {
    var sectionDragState = this.getDragState(DragItemTypes.SECTION),
        imageDropState = this.getDropState(DragItemTypes.IMAGE);

    return (
      <div className={this.getClassName()}
           data-state={this.getGalleryState()}
           data-hover={imageDropState.isHovering}
           data-hint={imageDropState.isDragging}
           data-dragging={sectionDragState.isDragging}
           {...this.dropTargetFor(DragItemTypes.IMAGE, DragItemTypes.SECTION)}>

        <div className='editor-Section-topBar'
             {...this.dragSourceFor(DragItemTypes.SECTION)}>
          <div className='editor-Section-type'>
            <Icon name='set' size='small' mode='stroke'/>
            <span className='editor-Section-typeTitle'>Set</span>
          </div>

          <div className='editor-Section-options'>
            <a className='editor-Section-layoutSwitch'
               title='Display as List'
               data-active={this.props.layout === 'list'}
               onClick={this.handleListClick}>
              <Icon name='list' size='small' mode='stroke' />
              <span className='editor-Section-layoutTitle'>List</span>
            </a>
            <a className='editor-Section-layoutSwitch'
               title='Display as Grid'
               data-active={this.props.layout === 'grid'}
               onClick={this.handleGridClick}>
              <Icon name='grid' size='small' mode='stroke' />
              <span className='editor-Section-layoutTitle'>Grid</span>
            </a>
          </div>

          <div className='editor-Section-delete'
               onClick={this.handleDeleteClick}>
            <Icon name='cross' size='xsmall' mode='stroke' />
          </div>
        </div>

        <div className='editor-SectionHint'>
          <div className='editor-SectionHint-box'>
            <p className='editor-SectionHint-message utils--smallCaps'></p>
          </div>
        </div>

        {!this.isEmpty() &&
          <div className='editor-Section-images'>
            {this.props.images.map(this.renderGalleryItem)}
          </div>
        }
      </div>
    );
  },

  renderGalleryItem(image) {
    var isNew = StampDraftStore.isLastAddedItem(image.uuid);

    return (
      <EditorGalleryImage key={image.uuid}
                          image={image}
                          isNew={isNew}
                          galleryId={this.props.uuid}
                          onDeleteClick={this.handleImageDeleteClick}
                          onDropToOtherSection={this.handleImageDropToOtherSection} />
    );
  },

  handleListClick() {
    DraftActionCreators.updateSection(this.props.uuid, {
      layout: GalleryLayouts.LIST
    });
  },

  handleGridClick() {
    DraftActionCreators.updateSection(this.props.uuid, {
      layout: GalleryLayouts.GRID
    });
  },

  handleImageDeleteClick(imageKey) {
    DraftActionCreators.deleteGalleryImage(this.props.uuid, imageKey);
  },

  handleImageDropToOtherSection(imageKey) {
    if (this.props.images.length > 1) {
      DraftActionCreators.deleteGalleryImage(this.props.uuid, imageKey);
    } else {
      DraftActionCreators.deleteSection(this.props.uuid);
    }
  },

  handleDeleteClick() {
    this.props.onDeleteClick(this.props.uuid, this.props.images.length > 0);
  }
});

module.exports = EditorGallery;



/** WEBPACK FOOTER **
 ** ./editor/EditorGallery.jsx
 **/